// A reply in a conversation: what it answers, and its subject.

/** What a reply in the conversation answers: the message and its subject. */
export interface ReplyTo {
  message_id: string
  subject: string | null
}

/** "Re: <their subject>", once. */
export const reSubject = (subject: string | null) => (subject && /^\s*re\s*:/i.test(subject) ? subject.trim() : `Re: ${subject?.trim() || 'our conversation'}`)
